export default "__VITE_ASSET__BrDU5UpM__"